import React from "react";

import formatCurrency from "Utils/formatCurrency";
import getTooltip from "Utils/getTooltip";

import { Popover } from "Cobalt/Popover";
import { Rating } from "Cobalt/Rating";
import { Table, TR, TD, EllipsisTD } from "Cobalt/TableV2";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import SIOverlay from "Common/SIOverlay";

import type { MedicalPlanPrice } from "Utils/types";

/** Map the highest coverage tier to network "strength" (1-4) */
const mapCoverageToRating = {
  regional_coverage: 1,
  state_coverage: 2,
  limited_nationwide_coverage: 3,
  full_nationwide_coverage: 4,
};
export const HighlightsTable = ({ plan, ...props }: { plan: MedicalPlanPrice }) => {
  const networkStrength = plan.network_size || mapCoverageToRating[plan.highest_coverage_tier] || 2;
  return (
    <Div {...props}>
      <Table>
        <tbody>
          <TR highlightFirstCell={false}>
            <TD width="180px">
              <SIOverlay
                placement="right"
                overlayContent={
                  <Popover showBackdrop={false} id="oop_max">
                    {getTooltip("Annual Out-of-Pocket Limit")}
                  </Popover>
                }
                overlayTarget={
                  <>
                    Out-of-Pocket Max
                    <Icon ml={3} icon="question-circle" />
                  </>
                }
              />
            </TD>
            <TD>{formatCurrency(plan.limit)}</TD>
          </TR>
          <TR highlightFirstCell={false}>
            <TD>Network Name</TD>
            <EllipsisTD>{plan.network}</EllipsisTD>
          </TR>
          <TR highlightFirstCell={false}>
            <TD>
              <SIOverlay
                placement="right"
                overlayContent={
                  <Popover showBackdrop={false} id="oop_max">
                    {getTooltip("Network Strength")}
                  </Popover>
                }
                overlayTarget={
                  <>
                    Network Size
                    <Icon ml={3} icon="question-circle" />
                  </>
                }
              />
            </TD>
            <TD>
              <SIOverlay
                placement="right"
                overlayContent={
                  <Popover showBackdrop={false} id="network_size">
                    {getTooltip("Network Strength", networkStrength)}
                  </Popover>
                }
                overlayTarget={<Rating value={networkStrength} max={4} />}
              />
            </TD>
          </TR>
          <TR highlightFirstCell={false}>
            <TD>Generic Drugs</TD>
            <TD>{formatCurrency(plan.estimated_costs.generic_drugs)}</TD>
          </TR>
        </tbody>
      </Table>
    </Div>
  );
};
